require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-labs-iv-presentation.json") })
        }
      }, "path---works-labs-iv-presentation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-labs-iv-presentation!./.cache/json/works-labs-iv-presentation.json
// module id = 382
// module chunks = 231608221292675